import Header from '../../components/blocks/Header';
import PageLayout from '../../layouts/PageLayout';
import Textblock from '../../components/blocks/Textblock';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';

import topVisual from '../../assets/images/fairplay-top.jpg';
import hollandCasino from '../../assets/images/fairplay-casino.jpg';

const FairPlay = () => {
    return (
        <PageLayout>
            <Header
                title="Eerlijk Spel"
                image={topVisual}
                description="Sinds 2021 is Holland Casino online responsible betting partner van de Eredivisie, Keuken Kampioen Divisie en ESPN. Als partners zorgen we samen voor een veilig en verantwoord kansspelaanbod, waarbij de integriteit van de sport volledig wordt gewaarborgd. Dat maakt deze samenwerking even logisch als gewenst. Wil je weten wat het responsible betting partnership precies inhoud? Lees hier meer!"
            />
            <Textblock
                title="Onze inzet"
                text="Het bieden van spelconcepten, activaties, producten en aantrekkelijke content die van toegevoegde waarde zijn voor de wedstrijdbeleving van alle voetbalfans. Om die toegevoegde waarde te kunnen leveren moeten we oog hebben voor de risico’s die kansspelen hebben. Daarin vervullen we onze sportieve plicht en zorgen zo dat alle fans kunnen blijven genieten van prachtige voetbalwedstrijden."
            />
            <Textblock
                title="Veilig & verantwoord nieuws"
                text={
                    <>
                        Holland Casino is sinds het seizoen 2021-2022
                        responsible betting partner van het complete Nederlandse
                        betaald voetbal. In de samenwerking tussen Holland
                        Casino, de Eredivisie, Keuken Kampioen Divisie en ESPN
                        staat veilig en verantwoord spelen en Fair Play altijd
                        voorop.
                        <ul className="list mt2">
                            <li>
                                <Link
                                    className="text"
                                    to="https://eredivisie.nl/nieuws/eerlijk-is-eerlijk/"
                                    target="blank"
                                >
                                    Eerlijk is Eerlijk
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="text"
                                    to="https://eredivisie.nl/nieuws/go-ahead-eagles-nieuwe-koploper-in-het-fair-play-klassement/"
                                    target="blank"
                                >
                                    Go Ahead nieuwe koploper in het Fair Play
                                    Klassement april
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="text"
                                    to="https://eredivisie.nl/nieuws/psv-nog-altijd-koploper-in-het-fair-play-klassement/"
                                    target="blank"
                                >
                                    PSV nog altijd koploper in het Fair Play
                                    Klassement februari
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="text"
                                    to="https://eredivisie.nl/nieuws/psv-nieuwe-koploper-in-het-fair-play-klassement/"
                                    target="blank"
                                >
                                    PSV nieuwe Koploper in het Fair Play
                                    Klassement januari
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="text"
                                    to="https://eredivisie.nl/nieuws/ajax-blijft-aan-kop-in-het-fair-play-klassement/"
                                    target="blank"
                                >
                                    Ajax blijft aan kop in het Fair Play
                                    Klassement december
                                </Link>
                            </li>
                        </ul>
                    </>
                }
            />
            <Textblock
                title="Wat voor een speler ben jij?"
                text={
                    <>
                        Plaats jij wel eens een weddenschap of speel je wel eens
                        een online casinospel bij Holland Casino Online?
                        Spannend, maar het moet wél leuk blijven. Test je
                        speelgedrag met onze zelftest en ontdek hoe verantwoord
                        jij speelt en wat voor type speler je bent. De inzichten
                        helpen je om nooit meer te spelen dan verantwoord voor
                        je is.
                        <Button
                            className="mt2"
                            type="primary"
                            size="large"
                            label="Doe hier de zelftest"
                        />
                    </>
                }
            />
            <Textblock
                title="Veilig, verantwoord en eerlijk bij Holland Casino Online"
                text={
                    <>
                        Wedden op sportwedstrijden is leuk en spannend, maar
                        niet zonder risico's. Holland Casino doet er alles aan
                        om er zeker van te zijn dat voetbalfans op het meest
                        betrouwbare spelaanbod kunnen rekenen en we onze
                        zorgplicht voor iedereen die bij ons speelt secuur en
                        professioneel vervullen. Waar je op wedt of speelt is
                        geverifieerd en betrouwbaar, en we helpen je binnen jouw
                        grenzen te blijven. Daarnaast spannen we ons in om
                        spelers en clubs te beschermen tegen onrechtmatigheden
                        en ongewenste bijeffecten van sportweddenschappen.
                    </>
                }
                image={hollandCasino}
                imgSize={40}
            />
            <Textblock
                title="Een 'responsible' partnership"
                text={
                    <>
                        Een fundamenteel onderdeel van ons partnership is om
                        invulling te geven aan responsible gambling. Want
                        eerlijk is eerlijk: het aanbod van sportweddenschappen
                        brengt zowel kansen als risico’s met zich mee voor de
                        voetbalwereld.
                        <br />
                        <br />
                        Samen zijn we eerlijk en open over de risico's zoals
                        sportgerelateerde matchfixing, kansspelgerelateerde
                        problematiek en kansspelverslaving en fraude. Met onze
                        Eerlijk is Eerlijk strategie ontwikkelen we concrete
                        programma’s en initiatieven waarmee we deze risico’s
                        benoemen en beperken.
                    </>
                }
            />
            <Textblock title="Zo houden we het eerlijk" margin={4} />
            <Textblock
                title="Eerlijk is eerlijk"
                h={3}
                margin={4}
                text={
                    <>
                        Met onze Eerlijk is Eerlijk strategie ontwikkelen we
                        concrete programma's en initiatieven waarmee we deze
                        risico's benoemen en beperken.
                        <ul className="list mt2">
                            <li>
                                <Link
                                    className="mt2"
                                    to="https://eredivisie.nl/ontdek/eerlijk-spel/eerlijk-is-eerlijk/"
                                    target="blank"
                                >
                                    Lees hier meer over Eerlijk is Eerlijk
                                </Link>
                            </li>
                        </ul>
                    </>
                }
            />
            <Textblock
                title="Fair Play Award"
                h={3}
                margin={4}
                text={
                    <>
                        Sinds het seizoen 2021-2022 reikt de Eredivisie met
                        Holland Casino en ESPN een Fair Play Award uit voor het
                        meest 'eerlijke' team. De winnaar wordt gehuldigd
                        tijdens de Eredivisie Awards.
                        <ul className="list mt2">
                            <li>
                                <Link
                                    className="mt2"
                                    to="https://eredivisie.nl/ontdek/eerlijk-spel/fair-play-award/"
                                    target="blank"
                                >
                                    Lees hier meer over de Fair Play Award
                                </Link>
                            </li>
                        </ul>
                    </>
                }
            />
            <Textblock
                title="Achtergrond partnership"
                h={3}
                margin={4}
                text={
                    <>
                        Sinds 2021-2022 is Holland Casino Responsible Betting
                        Partner van de Eredivisie, Keuken Kampioen Divisie en
                        ESPN. Lees hier meer over de achtergrond van het
                        partnership.
                        <ul className="list mt2">
                            <li>
                                <Link
                                    className="mt2"
                                    to="https://eredivisie.nl/ontdek/eerlijk-spel/achtergrond/"
                                    target="blank"
                                >
                                    Lees hier meer over de achtergrond van het
                                    partnership
                                </Link>
                            </li>
                        </ul>
                    </>
                }
            />
        </PageLayout>
    );
};

export default FairPlay;
